// Potvrzovací shrnutí před náročným skupinovým dotazem — obdoba gate v MeasGrafTable
// (doc/plans/station-group-meas.md sekce 4a-i). U tabulkových produktů (grp-mly/grp-yly/grp-jevy)
// jde hlavně o počet HTTP požadavků (1 na stanici, případně × N tsId), ne o výkon renderu.
//
// Použití: rodič drží `confirmed` state (resetuje ho remountem přes key = množina stanic + produkt),
// a když !confirmed && stationCount > threshold, vykreslí <GroupLoadGate> místo obsahu.
export function GroupLoadGate({ stationCount, requestNote, onConfirm }) {
  return (
    <div className="m-4 flex flex-col gap-3 items-start bg-amber-50 border border-amber-200 rounded-lg p-4 text-sm text-amber-800">
      <p>
        Tento výběr obsahuje <strong>{stationCount}</strong>{' '}
        {stationCount === 1 ? 'stanici' : stationCount < 5 ? 'stanice' : 'stanic'}.
        {requestNote ? ` ${requestNote}` : ' Načtení může chvíli trvat.'}
      </p>
      <button
        onClick={onConfirm}
        className="px-3 py-1.5 rounded-lg bg-amber-600 text-white text-xs font-medium hover:bg-amber-700"
      >
        Zobrazit i přesto
      </button>
    </div>
  )
}
